"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.initMarker = void 0;
const browser_1 = __importDefault(require("@marker.io/browser"));
const defaultOptions = { enabled: (_a = process.env.NODE_ENV === 'production') !== null && _a !== void 0 ? _a : false, destination: '' };
function initMarker(options = defaultOptions) {
    return __awaiter(this, void 0, void 0, function* () {
        const { enabled } = options, widgetOptions = __rest(options, ["enabled"]);
        if (!widgetOptions.destination || !enabled)
            return;
        try {
            yield browser_1.default.loadWidget(widgetOptions);
        }
        catch (e) {
            console.log(e);
        }
    });
}
exports.initMarker = initMarker;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvbWFya2VyL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLGlFQUEwQztBQVkxQyxNQUFNLGNBQWMsR0FBc0IsRUFBRSxPQUFPLEVBQUUsTUFBQSxPQUFPLENBQUMsR0FBRyxDQUFDLFFBQVEsS0FBSyxZQUFZLG1DQUFJLEtBQUssRUFBRSxXQUFXLEVBQUUsRUFBRSxFQUFXLENBQUE7QUFFL0gsU0FBZSxVQUFVLENBQUMsVUFBbUIsY0FBYzs7UUFDekQsTUFBTSxFQUFFLE9BQU8sS0FBdUIsT0FBTyxFQUF6QixhQUFhLFVBQUssT0FBTyxFQUF2QyxXQUE2QixDQUFVLENBQUE7UUFDN0MsSUFBSSxDQUFDLGFBQWEsQ0FBQyxXQUFXLElBQUksQ0FBQyxPQUFPO1lBQUUsT0FBTTtRQUNsRCxJQUFJO1lBQ0YsTUFBTSxpQkFBUyxDQUFDLFVBQVUsQ0FBQyxhQUFhLENBQUMsQ0FBQTtTQUMxQztRQUFDLE9BQU8sQ0FBQyxFQUFFO1lBQ1YsT0FBTyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQTtTQUNmO0lBQ0gsQ0FBQztDQUFBO0FBRVEsZ0NBQVUifQ==